{
  "metadata": {
    "id": "tundra-light",
    "name": "Tundra",
    "description": "Собственная тема Synth «Tundra» (light)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 21.0,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.289,
      "paletteMaxS": 0.364,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.2,
      "syntaxVsTextMinDeltaE": 22.4,
      "chartsMinDeltaE": 28.2,
      "textSeparationDeltaE": 16.5,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "comment",
          "b": "operator",
          "deltaE": 6.0
        },
        {
          "a": "string",
          "b": "function",
          "deltaE": 15.4
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#3F6B4A",
      "hover": "#396043",
      "active": "#34583d",
      "foreground": "#ffffff",
      "muted": "#3f6b4a80",
      "emphasis": "#3F6B4A"
    },
    "surface": {
      "background": "#F4F7F1",
      "foreground": "#1B231C",
      "muted": "#c5c9c2",
      "mutedForeground": "#3f473f",
      "elevated": "#aeb3ad",
      "elevatedForeground": "#1B231C",
      "raised": "#939891",
      "raisedForeground": "#1B231C",
      "overlay": "#f4f7f133",
      "subtle": "#dce0d9"
    },
    "interactive": {
      "border": "#8c918a",
      "borderHover": "#b7bcb5",
      "borderFocus": "#3F6B4A",
      "selection": "#1b231c24",
      "selectionForeground": "#1B231C",
      "focus": "#3f6b4a59",
      "focusRing": "#3f6b4a47",
      "cursor": "#121a13",
      "hover": "#1b231c17",
      "active": "#1b231c24"
    },
    "status": {
      "error": "#A33B32",
      "errorForeground": "#ffffff",
      "errorBackground": "#a33b321a",
      "errorBorder": "#a33b3259",
      "warning": "#8A6212",
      "warningForeground": "#ffffff",
      "warningBackground": "#8a62121a",
      "warningBorder": "#8a621259",
      "success": "#3D6B2E",
      "successForeground": "#ffffff",
      "successBackground": "#3d6b2e1a",
      "successBorder": "#3d6b2e59",
      "info": "#2F6F6F",
      "infoForeground": "#ffffff",
      "infoBackground": "#2f6f6f1a",
      "infoBorder": "#2f6f6f59"
    },
    "pr": {
      "open": "#3D6B2E",
      "draft": "#4c554c",
      "blocked": "#8A6212",
      "merged": "#5C7A29",
      "closed": "#A33B32"
    },
    "syntax": {
      "base": {
        "background": "#c5c9c2",
        "foreground": "#1B231C",
        "comment": "#4c574c",
        "keyword": "#335c00",
        "string": "#195b4b",
        "number": "#734b0f",
        "function": "#295d37",
        "variable": "#243C2A",
        "type": "#535318",
        "operator": "#4c554c"
      },
      "tokens": {
        "commentDoc": "#4c574c",
        "stringEscape": "#4c554c",
        "keywordImport": "#335c00",
        "storageModifier": "#335c00",
        "functionCall": "#295d37",
        "method": "#295d37",
        "variableProperty": "#295d37",
        "variableOther": "#243C2A",
        "variableGlobal": "#734b0f",
        "variableLocal": "#4c554c",
        "parameter": "#243C2A",
        "constant": "#734b0f",
        "class": "#535318",
        "className": "#535318",
        "interface": "#535318",
        "struct": "#535318",
        "enum": "#535318",
        "typeParameter": "#535318",
        "namespace": "#535318",
        "module": "#335c00",
        "tag": "#335c00",
        "jsxTag": "#335c00",
        "tagAttribute": "#295d37",
        "tagAttributeValue": "#195b4b",
        "boolean": "#734b0f",
        "decorator": "#335c00",
        "label": "#295d37",
        "regexp": "#195b4b"
      }
    },
    "charts": {
      "series": [
        "#3F6B4A",
        "#2f5a6f",
        "#227729",
        "#8A6212",
        "#A33B32"
      ]
    },
    "chat": {
      "background": "#F4F7F1",
      "userMessage": "#1B231C",
      "userMessageBackground": "#aeb3ad",
      "assistantMessage": "#1B231C",
      "assistantMessageBackground": "#c5c9c2",
      "timestamp": "#4c554c",
      "divider": "#8c918a",
      "typing": "#4c554c"
    },
    "loading": {
      "spinner": "#3F6B4A",
      "spinnerTrack": "#c5c9c2",
      "skeleton": "#c5c9c2",
      "shimmer": "#bbbfb8"
    },
    "tools": {
      "background": "#c5c9c2",
      "border": "#8c918a",
      "headerHover": "#bcc1ba",
      "icon": "#3F6B4A",
      "title": "#1B231C",
      "description": "#4c554c",
      "edit": {
        "added": "#3D6B2E",
        "addedBackground": "#3d6b2e1a",
        "removed": "#A33B32",
        "removedBackground": "#a33b321a",
        "modified": "#2F6F6F",
        "modifiedBackground": "#2f6f6f1a",
        "lineNumber": "#4c554c"
      }
    },
    "markdown": {
      "heading1": "#1B231C",
      "heading2": "#1B231C",
      "heading3": "#1B231C",
      "heading4": "#1B231C",
      "link": "#3F6B4A",
      "linkHover": "#396043",
      "inlineCode": "#195b4b",
      "inlineCodeBackground": "#c5c9c2",
      "blockquote": "#4c554c",
      "blockquoteBorder": "#8c918a",
      "listMarker": "#3f6b4abf",
      "bold": "#1B231C",
      "italic": "#1b231ce6",
      "strikethrough": "#4c554c",
      "hr": "#8c918a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#824043",
        "foreground": "#ffffff",
        "contrast": 7.6
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#986a4c",
        "foreground": "#ffffff",
        "contrast": 4.67
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#b7a56b",
        "foreground": "#000000",
        "contrast": 8.61
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#747d4d",
        "foreground": "#000000",
        "contrast": 4.78
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#9cb86c",
        "foreground": "#000000",
        "contrast": 9.49
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#468546",
        "foreground": "#000000",
        "contrast": 4.7
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#73ad8b",
        "foreground": "#000000",
        "contrast": 8.08
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#4f7867",
        "foreground": "#ffffff",
        "contrast": 4.98
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#77a5a8",
        "foreground": "#000000",
        "contrast": 7.73
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#658eb3",
        "foreground": "#000000",
        "contrast": 6.07
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4b5b75",
        "foreground": "#ffffff",
        "contrast": 6.88
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#444892",
        "foreground": "#ffffff",
        "contrast": 8.12
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8171a3",
        "foreground": "#000000",
        "contrast": 4.82
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a064b2",
        "foreground": "#000000",
        "contrast": 4.96
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#82416d",
        "foreground": "#ffffff",
        "contrast": 7.18
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#a57287",
        "foreground": "#000000",
        "contrast": 5.36
      }
    ]
  }
}
